import { useEffect, useRef } from 'react';
import { TEPLOHOD_SCRIPT_URL } from '../../lib/api/apiUrl';
import { Action } from '../../models';

export function ActionWidget({ action }: { action: Action }) {
  const widget = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (widget.current && action.widget_script) {
      widget.current.innerHTML = action.widget_script.split(';').join('');

      const script = document.createElement('script');
      script.setAttribute('src', TEPLOHOD_SCRIPT_URL);
      document.head.appendChild(script);
    }
  }, []);

  return <div ref={widget} />;
}
